import { render, staticRenderFns } from "./ShippingEstimate.vue?vue&type=template&id=06380f3a"
import script from "./ShippingEstimate.vue?vue&type=script&lang=js"
export * from "./ShippingEstimate.vue?vue&type=script&lang=js"
import style0 from "./ShippingEstimate.vue?vue&type=style&index=0&id=06380f3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports